import React, { useEffect } from 'react';
import { CloseButton } from 'react-bootstrap';
import { useLocalization } from '../contexts/LocalizationContext';
import useNotifications from '../hooks/useNotifications';

export default function NotificationManager() {
  const { remove, data } = useNotifications();

  return (
    <div
      className='d-flex flex-column justify-content-start align-items-start position-fixed gap-1 overflow-y-auto'
      style={{
        position: 'fixed',
        bottom: '0.5rem',
        left: '0.5rem',
        zIndex: '10002',
        minWidth: '20rem',
        maxWidth: 'calc(100vw- 2rem)',
        maxHeight: '100vh',
        marginRight: '0.5rem'
      }}>
      {data.items.map((notification) => (
        <Notification
          key={notification.id}
          remove={() => remove(notification.id)}
          data={notification}
        />
      ))}
    </div>
  );
}

function Notification({ data, remove }) {
  const { localize } = useLocalization();

  let timer;
  useEffect(() => {
    if (data?.timeout) {
      timer = setTimeout(() => {
        clearTimeout(timer);
        remove();
      }, data.timeout * 1000);
    }
    return () => clearTimeout(timer);
  }, [data]);

  return (
    <div
      className={
        'rounded bg-dark text-light px-4 py-3 notification' +
        (data.variant ? ` border-start border-5 border-${data.variant}` : '')
      }>
      <div className='position-relative'>
        <div className='me-5 d-flex align-items-center'>
          {data.icon && <div className='me-3'>{data.icon}</div>}
          <div>
            {data.localize
              ? localize(data.content, { editable: false })
              : data.content}
          </div>
        </div>
        <CloseButton
          variant='white'
          onClick={remove}
          style={{
            position: 'absolute',
            right: '0',
            top: '50%',
            transform: 'translateY(-50%)'
          }}
        />
      </div>
    </div>
  );
}
